import { Button } from '@chakra-ui/react'; // TODO: import from design-system
import { Link } from '@terminal/design-system';

export const PrimaryButton = (props) => {
  const ButtonType = (props) => {
    if (props.href) {
      return (
        <Link
          href={props.href}
          display="inline-flex"
          alignItems="center"
          justifyContent="center"
          {...props}
        >
          {props.children}
        </Link>
      );
    } else {
      return <Button {...props}>{props.children}</Button>;
    }
  };

  return (
    <ButtonType
      fontFamily="body"
      fontSize="0.75rem"
      borderRadius="0.25rem"
      fontWeight="700"
      textTransform="uppercase"
      color="#fff"
      bgColor="rgba(135, 183, 92, 1)"
      minW="12.5rem"
      h="2.5rem"
      letterSpacing="0.15rem"
      _hover={{
        backgroundColor: 'rgba(135, 183, 92, 0.8)',
      }}
      transition="all .3s ease-in-out"
      {...props}
    >
      {props.children}
    </ButtonType>
  );
};

export const SecondaryButton = (props) => {
  return (
    <PrimaryButton
      bgColor="rgba(122, 166, 185, 1)"
      _hover={{
        backgroundColor: 'rgba(122, 166, 185, 0.8)',
      }}
      {...props}
    >
      {props.children}
    </PrimaryButton>
  );
};
